import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type AutomationsAnalyticsPromptMode, withAutomationsCategory } from './automationsAnalytics';
import META from './useTrackAutomationSaveAsSkillStarted.meta';

export type UseTrackAutomationSaveAsSkillStartedParams = {
  automation_id: string;
  prompt_mode: AutomationsAnalyticsPromptMode;
};

export const useTrackAutomationSaveAsSkillStarted = () => {
  const { track } = useAnalyticsUtilities();

  const trackAutomationSaveAsSkillStarted = useCallback(
    (params: UseTrackAutomationSaveAsSkillStartedParams) => {
      track(META.name, withAutomationsCategory(params));
    },
    [track],
  );

  return { trackAutomationSaveAsSkillStarted };
};
